import React, { useState } from 'react';
import HeroSection from '@/components/HeroSection';
import PartnerMarquee from '@/components/PartnerMarquee';
import CombinedProblemSolution from '@/components/CombinedProblemSolution';
import VenueFinder from '@/components/VenueFinder';
import DogProfiles from '@/components/DogProfiles';
import FundingGoals from '@/components/FundingGoals';
import HostApplicationForm from '@/components/HostApplicationForm';
import Footer from '@/components/Footer';

const HomePage = () => {
  const [showHostForm, setShowHostForm] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <HeroSection />
      <PartnerMarquee />
      <CombinedProblemSolution />
      <VenueFinder />
      <DogProfiles />
      <FundingGoals />
      <Footer />
      
      {showHostForm && (
        <HostApplicationForm onClose={() => setShowHostForm(false)} />
      )}
    </div>
  );
};

export default HomePage;
